import * as React from 'react';
import Typography from '@mui/material/Typography';
import {Box, styled} from '@mui/material';

const FooterStyled = styled(Box)(({theme}) => ({
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#F0F4F8',
}));

const Footer = () =>
    <>
        <FooterStyled data-testid="app-footer">
            <Typography sx={{color: '#525756'}}>Admicity © {new Date().getFullYear()}</Typography>
        </FooterStyled>
    </>

export default Footer;